module.exports = __webpack_public_path__ + "assets/img/29da-sc.svg";